<app-menu-bar></app-menu-bar>

<div class="admin-page">
    <div class="admin-container">
        <app-admin-nav></app-admin-nav>

        <div class="toolbar">
            <div class="search">
                <i class="fa-light fa-magnifying-glass" aria-hidden="true"></i>
                <input type="text" [(ngModel)]="search"
                    [placeholder]="'admin_projects_search_placeholder' | translate" autocomplete="off" />
            </div>
            <button class="add-btn" type="button" (click)="openAdd()">{{ 'admin_projects_add' | translate }}</button>
        </div>

        <p class="state-text intro">
            {{ 'admin_projects_intro' | translate }}
            @if (canReorder) {
                {{ 'admin_projects_intro_reorder' | translate }}
            } @else if (search.trim()) {
                <!-- Renumbering runs over the whole list, so a filtered subset
                     cannot be dragged without scrambling the hidden rows. -->
                <strong>{{ 'admin_projects_intro_clear_search' | translate }}</strong>
            }
        </p>

        @if (loading) {
            <p class="state-text">{{ 'admin_loading' | translate }}</p>
        } @else if (projects.length === 0) {
            <p class="state-text">{{ 'admin_projects_empty' | translate }}</p>
        } @else if (filtered.length === 0) {
            <p class="state-text">{{ 'admin_projects_no_match' | translate }}</p>
        } @else {
            <div class="table-wrap">
                <table class="admin-table">
                    <thead>
                        <tr>
                            <!-- The drag handle has no header of its own — it moved into
                                 the Display order cell, which is the thing it changes.
                                 Actions is blank to match every other admin table; it
                                 carried a label for a while, so the eye would not pair
                                 each header with whichever column sat nearest. -->
                            <th class="order-col">{{ 'project_field_display_order' | translate }}</th>
                            <th class="thumb-col">{{ 'admin_projects_table_image' | translate }}</th>
                            <th>{{ 'field_title' | translate }}</th>
                            <th>{{ 'field_location' | translate }}</th>
                            <th>{{ 'field_industry' | translate }}</th>
                            <th class="lang-col">{{ 'admin_projects_table_translations' | translate }}</th>
                            <th class="actions-col"></th>
                        </tr>
                    </thead>
                    <tbody cdkDropList [cdkDropListData]="filtered" [cdkDropListDisabled]="!canReorder"
                        (cdkDropListDropped)="onDrop($event)">
                        @for (item of filtered; track item.id) {
                            <!-- cdkDragEnded fires however the drag finishes, including a
                                 release outside the list, so the pinned widths always come off. -->
                            <!-- previewContainer="parent" is load-bearing: CDK appends the
                                 preview to <body> by default, where this component's
                                 encapsulated .cdk-drag-preview styles cannot reach it, so the
                                 preview rendered as an unstyled bare <tr>. Inserting it into the
                                 tbody keeps it inside the component's DOM.
                                 cdkDragEnded fires however the drag finishes, including a
                                 release outside the list, so the pinned widths always come off. -->
                            <tr cdkDrag [cdkDragData]="item" cdkDragLockAxis="y" [cdkDragDisabled]="!canReorder"
                                cdkDragPreviewContainer="parent" (cdkDragEnded)="unlockRowWidths()">
                                <td class="order-col">
                                    <!-- Handle rather than the whole row: the row also holds
                                         buttons and selectable text. Paired with the number it
                                         changes, so this column needs no separate header. -->
                                    <span class="grip" cdkDragHandle
                                        (pointerdown)="lockRowWidths($event)"
                                        [class.disabled]="!canReorder"
                                        [matTooltip]="(canReorder ? 'admin_projects_drag_to_reorder' : 'admin_projects_clear_search_to_reorder') | translate"
                                        matTooltipClass="admin-tooltip">
                                        <fa-icon [icon]="faGripVertical"></fa-icon>
                                    </span>
                                    @if (item.displayOrder !== null) {
                                        <span class="order-value">{{ item.displayOrder }}</span>
                                    } @else {
                                        <span class="order-value muted"
                                            [matTooltip]="'admin_projects_sorts_last' | translate"
                                            matTooltipClass="admin-tooltip">—</span>
                                    }
                                </td>
                                <td class="thumb-col">
                                    @if (item.image && !imageBroken(item)) {
                                        <span class="thumb-slot">
                                            @if (imagePending(item)) {
                                                <!-- Holds the slot while a signed S3 URL is still in flight. -->
                                                <span class="thumb-skeleton" aria-hidden="true"></span>
                                            }
                                            <img [src]="item.image" [alt]="item.title" class="thumb"
                                                loading="lazy" decoding="async"
                                                [class.is-loaded]="!imagePending(item)"
                                                (load)="onImageLoad(item)" (error)="onImageError(item)" />
                                        </span>
                                    } @else {
                                        <span class="no-thumb" [matTooltip]="'admin_no_image' | translate"
                                            matTooltipClass="admin-tooltip">—</span>
                                    }
                                </td>
                                <td class="title">{{ item.title }}</td>
                                <td>{{ item.location || '—' }}</td>
                                <td>{{ item.industry || '—' }}</td>
                                <td class="lang-col">
                                    <!-- An icon rather than a pill: the state is binary and the
                                         detail belongs in the tooltip, which names the languages
                                         and what a visitor actually sees. -->
                                    <span class="lang-state"
                                        [class.ok]="!missingLanguages(item).length"
                                        [class.warn]="missingLanguages(item).length"
                                        [matTooltip]="translationTooltip(item)"
                                        matTooltipClass="admin-tooltip">
                                        <fa-icon [icon]="missingLanguages(item).length
                                            ? faTriangleExclamation : faCircleCheck"></fa-icon>
                                    </span>
                                </td>
                                <td class="actions-col">
                                    <button type="button" class="icon-btn" (click)="openEdit(item)"
                                        [matTooltip]="'admin_action_edit' | translate" matTooltipClass="admin-tooltip">
                                        <fa-icon [icon]="faPen"></fa-icon>
                                    </button>
                                    <button type="button" class="icon-btn danger" (click)="remove(item)"
                                        [matTooltip]="'admin_action_delete' | translate" matTooltipClass="admin-tooltip">
                                        <fa-icon [icon]="faTrash"></fa-icon>
                                    </button>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        }
    </div>
</div>

<app-footer></app-footer>
